<template>
  <div class="reset-box">
    <div class="reset-box-1">
      <h3>重置密码</h3>
      <div class="reset-box-1-bottom">
        <Form
          class="F"
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          label-position="top"
          @keyup.enter.native="handleSubmit('formInline')"
        >
          <FormItem prop="password" label="新密码">
            <Input type="password" v-model="formInline.password" placeholder="请输入新密码" />
          </FormItem>
          <FormItem prop="passwdCheck" label="确认密码">
            <Input type="password" v-model="formInline.passwdCheck" placeholder="请输入确认密码" />
          </FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            size="large"
            :loading="loading"
            style="margin-top: 24px;"
          >提交</Button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "reset-password2",
  data() {
    const that = this;
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== that.formInline.password) {
        callback(new Error("确认密码和原密码不一致"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      formInline: {
        password: "",
        passwdCheck: ""
      },
      ruleInline: {
        passwdCheck: [{ validator: validatePassCheck, trigger: "blur" }],
        password: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 12,
            message: "密码不能大于于12位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  async created() {},
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      setPassword: "loginModule/setPassword"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {
        UserId: this.user. userId,
        NewPassword: form.password
        // JoinId: "<展商修改密码需要>"
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.setPassword(formData);
      if (tokenData) {
        this.$Message.success("修改成功");
        this.$router.push("/login/succeed");
      }
      this.loading = false;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    }
  }
};
</script>

<style lang='scss'>
.reset-box {
  width: 420px;
  min-height: 392px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 70px auto 0;
  &-1 {
    width: 420px;
    min-height: 348px;
    background-color: #fff;
    border-radius: 2px;
    position: relative;
    h3 {
      text-align: center;
      font-size: 20px;
      color: #333;
      font-weight: bold;
      margin-bottom: 40px;
    }
    &-top {
      width: 332px;
      height: 40px;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
      .p2 {
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        cursor: pointer;
        color: #666;
        &.active,
        &:hover {
          color: #d13119;
        }
      }
      .p3 {
        color: #808080;
        &:hover {
          color: #d13119;
        }
      }
    }
    &-bottom {
      width: 360px;
      min-height: 350px;
      margin: 0 auto;
    }
  }
  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    img {
      width: 13px;
      height: 11px;
    }
  }
}
.F {
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 350px;
  position: relative;
  .ivu-input {
    height: 42px;
  }
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .I {
      margin-top: 19px;
    }
  }
  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: flex-end;
    margin: 24px 0;
    .F-2-text {
      width: 60px;
      height: 13px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
    }
  }
  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }
}
.form-code-item {
  position: relative;
  .form-code-btn {
    position: absolute;
    right: -2px;
    width: 96px;
    top: 6px;
    border: none;
    outline: none;
    background: transparent;
    &:focus {
      box-shadow: none;
      border: none;
      outline: none;
    }
  }
}
.login-re {
  text-align: center;
  margin-top: 20px;
  span {
    text-decoration: underline;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }
}
</style>